import { ErrorAlert } from "./Alert";
import { axiosClient } from "./apiClient";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
// import { ErrorAlert } from "../Common/Alert";

export function getMachineList(data) {
  try {
    return axiosClient.post("Machine/getlist", data).then((res) => {
      return res;
    });
  } catch (err) {
    ErrorAlert(err);
  }
}
export function getCategoryList(data) {
  try {
    return axiosClient.post("MachineCategory/getlist", data).then((res) => {
      return res;
    });
  } catch (err) {
    ErrorAlert(err);
  }
}
// export function getCategoryList(data) {
//   try {
//     return axiosClient.post("MachineCategory/getlist", data).then((res) => {
//       return res;
//     });
//   } catch (err) {
//     ErrorAlert(err);
//   }
// }


export function getAllParameter(data) {
  try {
    return axiosClient
      .post("Machine/getallmachineparameter", data)
      .then((res) => {
        return res;
      });
  } catch (err) {
    ErrorAlert(err);
  }
}


export function saveWorkFlow(data) {
  try {
    return axiosClient.post("WorkFlow/save", data).then((res) => {
      return res;
    });
  } catch (err) {
    ErrorAlert(err);
  }
}
export function Runworkflow(data) {
  try {
    return axiosClient.post("WorkFlow/run_workflow", data).then((res) => {
      return res;
    });
  } catch (err) {
    ErrorAlert(err);
  }
}

export function WorkFlowList(data) {
  try {
    return axiosClient.post("WorkFlow/getlist", data).then((res) => {
      return res;
    });
  } catch (err) {
    ErrorAlert(err);
  }
}

export function WrokFlowByID(data) {
  try {
    return axiosClient.post("WorkFlow/getdetailsbyprimarykey", data).then((res) => {
      return res;
    });
  } catch (error) {
    ErrorAlert(error);
  }
}

export function getWorkFlowLogDataByWorkFlowID(data) {
  try {
    const body = {
      workflowulogid: data?.workflowulogid || "",
      machineid:
        data?.machineid !== undefined && data?.machineid !== null && data?.machineid !== ""
          ? String(data.machineid)
          : "",
    };

    return apiCall(
      {
        method: "POST",
        url: API_URL.BASEURL + API_URL.GET_MACHINE_CHART_FROM_WORKFLOWULOGID,
        body,
      },
      true
    );
  } catch (err) {
    ErrorAlert(err);
  }
}


// function handleError(err) {
//   if (err.response) {
//     // Server responded with a status other than 2xx
//     const statusCode = err.response.status;
//     switch (statusCode) {
//       case 400:
//         ErrorAlert("Bad Request: Invalid data sent.");
//         break;
//       case 401:
//         ErrorAlert("Unauthorized: Please log in.");
//         break;
//       case 403:
//         ErrorAlert("Forbidden: You don't have permission to access this resource.");
//         break;
//       case 404:
//         ErrorAlert("Not Found: The requested resource could not be found.");
//         break;
//       case 500:
//         ErrorAlert("Internal Server Error: Something went wrong on the server.");
//         break;
//       default:
//         ErrorAlert(`Error: ${err.response.statusText}`);
//     }
//   } else if (err.request) {
//     // Request was made but no response received
//     ErrorAlert("Network error: No response received.");
//   } else {
//     // Something happened while setting up the request
//     ErrorAlert("Error: " + err.message);
//   }
// }